import { Howl } from 'howler'
import soundFileClose from '@/styles/mp3/close.mp3'
import soundFileBtn from '@/styles/mp3/btn.mp3'
import soundFileBgm from '@/styles/mp3/bgm.mp3'
import soundFileStar from '@/styles/mp3/star.mp3'
import soundFileEnd from '@/styles/mp3/end.mp3'
import soundFileStart from '@/styles/mp3/start.mp3'
import soundFileStamp from '@/styles/mp3/stamp.mp3'
import soundFileShootingStar from '@/styles/mp3/shootingstar.mp3'
import soundFileReload from '@/styles/mp3/reload.mp3'

class AudioPlayer {
  // Private static variable to hold the single instance
  private static instance: AudioPlayer | null = null;
  // all sound files Howl instance initialize only once
  private _backGroundSound: Howl | null = null;
  private _closeSound: Howl | null = null;
  private _buttonSound: Howl | null = null;
  private _starSound: Howl | null = null;
  private _endSound: Howl | null = null;
  private _startSound: Howl | null = null;
  private _stampSound: Howl | null = null;
  private _shootingStarSound: Howl | null = null;
  private _reloadSound: Howl | null = null;

  // Private constructor to prevent instantiation from outside
  private constructor() {}

  // Static method to get the single instance
  public static getInstance(): AudioPlayer {
    // Check if instance already exists, if not, create it
    if (!AudioPlayer.instance) {
      AudioPlayer.instance = new AudioPlayer();
    }
    return AudioPlayer.instance;
  }

  public closeSound(): Howl {
    // Check if Howl instance already exists, if not, create it
    if(!this._closeSound){
      this._closeSound = new Howl({
        src: [soundFileClose],
        volume: 1.0,
        html5: true,
        preload: false
      })
    }
    return this._closeSound
  }

  public buttonSound(): Howl {
    // Check if Howl instance already exists, if not, create it
    if(!this._buttonSound){
      this._buttonSound = new Howl({
        src: [soundFileBtn],
        volume: 1.0,
        html5: true,
        preload: false
      })
    }
    return this._buttonSound
  }

  public backGroundSound(): Howl {
    // Check if Howl instance already exists, if not, create it
    if(!this._backGroundSound){
      this._backGroundSound = new Howl({
        src: [soundFileBgm],
        volume: 1.0,
        html5: true,
        preload: false
      })
    }
    return this._backGroundSound
  }

  public starSound(): Howl {
    // Check if Howl instance already exists, if not, create it
    if(!this._starSound){
      this._starSound = new Howl({
        src: [soundFileStar],
        volume: 1.0,
        html5: true,
        preload: false
      })
    }
    return this._starSound
  }

  public endSound(): Howl {
    // Check if Howl instance already exists, if not, create it
    if(!this._endSound){
      this._endSound = new Howl({
        src: [soundFileEnd],
        volume: 1.0,
        html5: true,
        preload: false
      })
    }
    return this._endSound
  }

  public startSound(): Howl {
    // Check if Howl instance already exists, if not, create it
    if(!this._startSound){
      this._startSound = new Howl({
        src: [soundFileStart],
        volume: 1.0,
        html5: true,
        preload: false
      })
    }
    return this._startSound
  }

  public stampSound(): Howl {
    // Check if Howl instance already exists, if not, create it
    if(!this._stampSound){
      this._stampSound = new Howl({
        src: [soundFileStamp],
        volume: 1.0,
        html5: true,
        preload: false
      })
    }
    return this._stampSound
  }

  public shootingStarSound(): Howl {
    // Check if Howl instance already exists, if not, create it
    if(!this._shootingStarSound){
      this._shootingStarSound = new Howl({
        src: [soundFileShootingStar],
        volume: 1.0,
        html5: true,
        preload: false
      })
    }
    return this._shootingStarSound
  }

  public reloadSound(): Howl {
    // Check if Howl instance already exists, if not, create it
    if(!this._reloadSound){
      this._reloadSound = new Howl({
        src: [soundFileReload],
        volume: 1.0,
        html5: true,
        preload: false
      })
    }
    return this._reloadSound
  }
}

export default AudioPlayer;